







































































import {
  BForm,
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { DetailsUtilisateur } from "@/api/models/utilisateurs/utilisateur";
import { successAlert, errorAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BForm,
    BButton,
    BCard,
    BCol,
    BFormGroup,
    BFormInput,
    BRow,
    BSpinner,
  },
  name: "edit-utilisateur-smart-agenda",
})
export default class EditUtilisateurSmartAgenda extends Vue {
  @Prop({ required: true }) initialUtilisateur!: DetailsUtilisateur;
  selectedUtilisateur: DetailsUtilisateur | null = null;
  isUpdatingSmartAgendaUser = false;

  async mounted() {
    this.resetModel();
  }

  resetModel() {
    this.selectedUtilisateur = JSON.parse(
      JSON.stringify(this.initialUtilisateur)
    );
  }

  async creerUtilisateurSmartAgenda() {
    this.isUpdatingSmartAgendaUser = true;
    await this.$http.myressif.utilisateurs
      .createSmartAgendaUser(this.$route.params.id)
      .then(
        (res: any) => {
          successAlert.fire({
            title: "Création de l'utilisateur dans Smartagenda",
            text: "Création effectuée avec succès",
          });

          this.selectedUtilisateur!.idSmartAgenda = res;
          this.initialUtilisateur.idSmartAgenda =
            this.selectedUtilisateur!.idSmartAgenda;
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      );

    this.isUpdatingSmartAgendaUser = false;
  }

  async modifierUtilisateurSmartAgenda() {
    this.isUpdatingSmartAgendaUser = true;
    await this.$http.myressif.utilisateurs
      .updateSmartAgendaUser(
        this.$route.params.id,
        this.selectedUtilisateur!.idSmartAgenda!
      )
      .then(
        (res: any) => {
          successAlert.fire({
            title: "Modification de l'identifiant Smartagenda",
            text: "Modification effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      );

    this.isUpdatingSmartAgendaUser = false;
  }
}
